<template>
  <div id="app">
    <div class="address-wrapper">
      <div class="logo-band">
        <div class="logo-container">
          <div class="gemnote-logo">
            <img
              v-if="projectInfo.teamLogo && projectInfo.teamLogo.url"
              :src="projectInfo.teamLogo.url"
              alt="logo"
            />
          </div>
        </div>
      </div>
      <Notification />
      <div class="adderess-wrapper">
        <div class="address-wrapper-container">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notification from '../views/Notification'
import { mapState } from 'vuex'
import { progressStatus } from '@/helpers'

export default {
  name: 'GroupOrderLayout',
  components: {
    Notification
  },
  computed: {
    loadStatus() {
      return progressStatus(this.loadingProjectLinkInfo)
    },
    ...mapState({
      loadingProjectLinkInfo: state => state.project.loadingProjectLinkInfo,
      projectInfo: state => state.project.projectInfo
    })
  }
}
</script>

<style lang="scss">
@import '@/global.scss';

.address-wrapper {
  background: $main-white;
  height: auto;
}

.logo-band {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 3.5rem;
  border-bottom: 1px solid $main-5;
}

.logo-container {
  width: 100%;
  margin: 0 auto;
  padding: 0 2rem;
}

.gemnote-logo {
  img {
    height: 2rem;
  }
}

.adderess-wrapper {
  width: 100%;
  padding: 0 2rem;
}

.address-wrapper-container {
  width: 100%;
  margin: 0 auto;
}

@media screen and (min-width: 1400px) {
  .adderess-wrapper,
  .logo-container {
    min-width: 1400px;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 1rem;
  }
}

@media screen and (max-width: 699px) and (min-width: 500px) {
  .logo-band {
    height: 5rem;
  }

  .gemnote-logo {
    img {
      height: 3rem;
    }
  }
}

@media screen and (max-width: 499px) and (min-width: 320px) {
  .logo-band {
    height: 4rem;
  }

  .gemnote-logo {
    img {
      height: 3rem;
    }
  }
}
@media screen and (max-width: 699px) {
  .logo-container {
    padding: 0 1rem;
  }

  .adderess-wrapper {
    padding: 0;
  }

  .gemnote-logo {
    img {
      height: 2rem;
    }
  }

  .address-wrapper-container {
    padding: 0 1rem;
  }
}
</style>
